import React from 'react';

import Tooltip from '../../../../../UI/Tooltip/Tootip';
import seatImage from '../../../../../../assets/images/seat.png';

const boxSeat = (props) => ( 
    <div className={`u-block mr-auto u-phoneHide u-relative u-size24x24`}>
        <Tooltip style={{
            display: 'block'
        }} type="seatsLeft" aria-label={props.children === '1' ? `${props.children} seat left` : `${props.children} seats left`}>
            <img src={seatImage} alt='Seat' className={`u-width100Percent u-height100Percent`}/>
            <div className={`u-size16x16 u-borderRadius50 u-borderRed u-textColorRed u-flex align-items-center justify-content-center u-absolute u-topNegative2 u-rightNegative2`}><span className={`u-fontSize09 u-fontWeightMedium u-lineHeight1`}>{props.children}</span></div>
        </Tooltip>
    </div>
);

export default boxSeat;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Desktop/Tuple/BoxSeat/BoxSeat.js